import { COLOR } from '@src/styles/color';

export const variantMapping = {
  'dark-blue': {
    height: 4,
    borderRadius: 480,
    backgroundColor: COLOR.backgroundLinearProgress,
    barColor: COLOR.darkBlue,
    barBorderRadius: 480,
  },
  'light-blue': {
    height: 4,
    borderRadius: 480,
    backgroundColor: COLOR.backgroundLinearProgress,
    barColor: COLOR.textPending,
    barBorderRadius: 480,
  },
};
